import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { useSearchParams } from 'react-router-dom';
import { isNewUiAtom } from 'r/atoms/newUi';
import { showNotification } from 'r/utils';

export default function useNewUiToggle() {
  const [isNewUi, setIsNewUi] = useAtom(isNewUiAtom);
  const [searchParams, setSearchParams] = useSearchParams();
  const newUiParam = searchParams.get('newui');

  // `?newui=1` / `?newui=0` sets the mode, then the param is dropped from the URL
  useEffect(() => {
    if (newUiParam !== '1' && newUiParam !== '0') return;
    const isOn = newUiParam === '1';
    setIsNewUi(isOn);
    showNotification('info', `New UI: ${isOn ? 'on' : 'off'}`);
    setSearchParams(
      (params) => {
        params.delete('newui');
        return params;
      },
      { replace: true },
    );
  }, [newUiParam, setIsNewUi, setSearchParams]);

  // Ctrl+Alt+K toggles the mode. `code` keeps it layout-independent.
  useEffect(() => {
    const handleKey = (e: globalThis.KeyboardEvent) => {
      if (!e.ctrlKey || !e.altKey || e.shiftKey || e.metaKey) return;
      if (e.code !== 'KeyK' || e.repeat) return;
      e.preventDefault();
      setIsNewUi(!isNewUi);
      showNotification('info', `New UI: ${!isNewUi ? 'on' : 'off'}`);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isNewUi, setIsNewUi]);
}
